/** @format */

import React, {ComponentPropsWithoutRef} from 'react'

type ExternalLinkProps = Omit<ComponentPropsWithoutRef<'a'>, 'rel' | 'target'>

// ExternalLink is a thin wrapper for an anchor ('a') to ensure security
// best practice for opening a link to an external site.
export function ExternalLink(props: ExternalLinkProps) {
  return <a {...props} target="_blank" rel="noopener noreferrer" />
}
